import { createContext } from "react";
import type { Tenant } from "../models/Tenant";
import type { TenantThemeSettings } from "../models/TenantThemeSettings";

export type TenantResolutionStatus =
  | "Initializing"
  | "Found"
  | "NotFound"
  | "Error";

export interface ITenantContext {
  Tenant?: Tenant;
  TenantUrl: string;
  Theme: TenantThemeSettings;
  Status: TenantResolutionStatus;
  ResolveTenant: () => Promise<void>;
  PreviewTheme: (theme: TenantThemeSettings) => void;
  SaveTenant: (request: Tenant) => Promise<Tenant>;
}

export const TenantContext = createContext<ITenantContext | undefined>(
  undefined,
);
